<template>
  <vue-circle
    ref="circle"
    :progress="p"
    :size="100"
    :reverse="false"
    line-cap="round"
    :fill="fill"
    empty-fill="rgba(0, 0, 0, .1)"
    :animation-start-value="0.0"
    :start-angle="30"
    insert-mode="append"
    :precision="precision"
    :thickness="10"
    :show-percent="showPercent"
    :scale="scale"
    :legend-class="legend">
    <slot></slot>
  </vue-circle>
</template>

<script>
import VueCircle from "vue2-circle-progress-vk"

export default {
  name: "bpChart",
  props: { chartdata: { type: Object, required: true } },
  components: {
    VueCircle,
  },
  data() {
    return {
      p: null,
      scale: null,
      precision: null,
      showPercent: null,
      fill: {},
      legend: "s",
    }
  },

  created() {
    this.p = this.chartdata?.data ?? 0
    if (Array.isArray(this.chartdata.color)) {
      this.fill.gradient = this.chartdata.color
    } else {
      this.fill = this.chartdata.color
    }

    if (this.chartdata.meta) {
      this.showPercent = this.chartdata.meta.showPercent
      this.scale = this.chartdata.meta.scale
      this.precision = this.chartdata.meta.precision
      if (this.chartdata.meta.legendClass) {
        this.legend = this.chartdata.meta.legendClass
      }
    }
  },
}
</script>

<style scoped lang="sass">
.relocate_legend
  position: absolute
  bottom: -60px
</style>
